import { User } from 'contensis-management-api/lib/models';

export const AvatarMappings = {
  src: {
    $path: '.',
    $formatting: (user: User | undefined | any) => {
      const url = 'https://www.contensis.com';
      const endpoint = 'avatars';

      const matchesInitials =
        user?.fullName?.match(/\b(\w)/g) || user?.username?.match(/\b(\w)/g);
      const initials = matchesInitials?.join('').toUpperCase();

      const identifier =
        user?.authorEmail || user?.email || initials || user?.id;

      return `${url}/${endpoint}/${identifier}?size=32`;
    },
  },
  name: 'name',
};
